/* eslint-disable no-use-before-define */
import { getBrand, getSessionId, ajax, toQueryString, cleanObject, getConfig } from '../twd'

export default async (arg) => {
    let params = getParams(arg)

    let { data } = ajax({
        url: '/esb/portfolio/offersearch/export',
        method: 'POST',
        type: 'text',
        headers_: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: toQueryString({
            'DATA': JSON.stringify(params),
            'BRAND': getBrand(),
            'SESSIONID': getSessionId()
        })
    })

    let csv = await data
    let txt = csv.split('\n').slice(2).join('\n')
    let filename = 'Download.csv'

    if (navigator.msSaveBlob) {
        let blob = new Blob([txt], { type: 'text/csv;charset=utf-8;'})
        navigator.msSaveBlob(blob, filename)
        return
    }

    let a = document.createElement('a')
    a.download = filename
    a.href = `data:text/csv;base64,${btoa(txt)}`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

const getParams = ({selection, invType}) => {
    let cusips = selection.map(a => a.holdCusip).filter(Boolean)
    let filtered = getConfig('entitlements.SuppressedFieldsOnExcelExport', '')

    return {
        format: "csv",
        exportName: "offerings",
        columns: [
            {"field":"holdIssue","text":"Issue"},

            {"field":"moodyRating","text": "Mdy/S&P", "code": { "type": "join", "fields": ["moodyRating", "spRating"], "joiner": " / " } },

            {"field":"holdCoupon","text":"Coupon","code":{"type":"numFormat","value":"0.000"}},
            {"field":"couponPaymentFreq","text":"Frequency"},
            {"field":"holdMaturity","text":"Maturity","code":{"type":"mat"}},
            {"field":"holdFirstCall","text":"Next Call","code":{"type":"call"}},

            {"type":"C", "field":"corpType","text":"Corp Type"},
            {"type":"C", "field":"holdCorpSector","text":"Corp Sector"},
            filtered.indexOf('IDC-FP/FedFIS')>=0 ? null : {"type":"S", "field":"holdFdicNum","text":"FDIC Cert #"},
            {"type":"M", "field":"holdState","text":"State"},
            {"type":"M", "field":"muniType","text":"Muni Type"},
            {"type":"M", "field":"holdUseOfProceeds","text":"Muni Purpose"},
            {"type":"M", "field":"muniInsurance","text":"Muni Insurance"},

            {"field":"askQuantity","text":"Ask Qty"},
            {"field":"askQtyMin","text":"Ask Qty Min"},
            {"field":"askQtyIncr","text":"Ask Qty Incr"},
            {"field":"askPrice","text":"Ask Price"},
            {"field":"askYield","text":"Ask YTW","code":{"type":"yieldInd","fields":["askYield","askYtwInd"]}},
            {"field":"askYieldmat","text":"Ask YTM","code":{"type":"numFormat","value":"0.000"}},
            {"field":"askSettlement","text":"Ask Settle"},

            {"field":"bidQuantity","text":"Bid Qty"},
            {"field":"bidQtyMin","text":"Bid Qty Min"},
            {"field":"bidQtyIncr","text":"Bid Qty Incr"},
            {"field":"bidPrice","text":"Bid Price"},
            {"field":"bidYield","text":"Bid YTW","code":{"type":"yieldInd","fields":["bidYield","bidYtwInd"]}},
            {"field":"bidYieldmat","text":"Bid YTM","code":{"type":"numFormat","value":"0.000"}},
            {"field":"bidSettlement","text":"Bid Settle"}
        ]
        .filter(Boolean)
        .filter(a => !a.type || a.type===invType)
        .map( ({field, text, code}) => cleanObject({field, text, code}))
        ,
        searchCriteria: {
            searchType: "offers",
            offeringType: ["ask-side","bid-side"],
            holdCusip: cusips,
            holdIdentifiers: cusips,
            holdIdentifierLabel: "holdCusip",
            pageNumber: 1,
            resultsPerPage: cusips.length,
            sort: [{"field":"holdMaturitySortDt","direction":"ASC"}],
            persistToPreviousSearches: false,
            marketCheckRequired: false
        },
    }
}





// WEBPACK FOOTER //
// ./src/offerings/download.js